import { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthKit } from '../contexts/AuthProvider';
import { resolveLoginAction } from './loginEndpoint';

/**
 * `/login`: the WorkOS Sign-in endpoint (see loginEndpoint.ts). Mounted
 * OUTSIDE AuthGate/OrgProvider in main.tsx, since its job is to start a
 * sign-in, not to need one.
 */
export function LoginRoute() {
  const { isLoading, user, signIn } = useAuthKit();
  const { search } = useLocation();
  const [failed, setFailed] = useState(false);
  // One sign-in per visit: two concurrent signIn() calls each store their own
  // PKCE verifier and only one redirect wins, so the other's verifier would
  // reject the code (StrictMode also runs effects twice in dev).
  const started = useRef(false);

  const action = resolveLoginAction({ isLoading, signedIn: !!user, search });

  useEffect(() => {
    if (action.kind !== 'sign-in' || started.current) return;
    started.current = true;
    signIn(action.options).catch((err) => {
      console.error('Sign-in endpoint: could not start sign-in', err);
      setFailed(true);
    });
  }, [action, signIn]);

  // Already signed in, or the sign-in could not start: the landing page at `/`
  // is the way out in both cases.
  if (action.kind === 'home' || failed) return <Navigate to="/" replace />;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--ink, #060E18)',
        color: 'var(--gold, #D4952B)',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      Redirecting to sign in…
    </div>
  );
}
